function initMulticolumnDragSlider() {
  const sliders = document.querySelectorAll('.multicolumn-section .slider--desktop');

  sliders.forEach(slider => {
    let isDown = false;
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;

    // Prevent native drag of images/links so our custom scroll works smoothly
    slider.addEventListener('dragstart', (e) => {
      e.preventDefault();
    });

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      isDragging = false;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      // Disable CSS snap during drag for smoother experience
      slider.style.scrollSnapType = 'none';
    });

    slider.addEventListener('mouseleave', () => {
      if (!isDown) return;
      isDown = false;
      slider.classList.remove('active');
      slider.style.scrollSnapType = '';
    });

    slider.addEventListener('mouseup', () => {
      if (!isDown) return;
      isDown = false;
      slider.classList.remove('active');
      slider.style.scrollSnapType = '';
      setTimeout(() => isDragging = false, 10);
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      isDragging = true;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2; // Scroll speed multiplier
      slider.scrollLeft = scrollLeft - walk;
    });

    // Prevent accidental clicks on links when dragging
    slider.addEventListener('click', (e) => {
      if (isDragging) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initMulticolumnDragSlider);
// Re-initialize for theme editor events
document.addEventListener('shopify:section:load', initMulticolumnDragSlider);
